import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainContent", "ratingStar", "videoPlayer", "courseAbout", "courseSessions", "videoPlayerControl",
                    "progressBar", "currentLesson", "doneLessons", "lessonCheckbox", "leftLessonsDuration",
                    "totalLessonsDuration", "leftLessonsWatch", "totalLessonsWatch", "speakers"]

  connect() {
    this.controllerName = `mobile--marketing--courses--entities--public-show`
    this.courseSlug = location.pathname.split("/").pop()
    this.doCoursePreloaderHtml()
    this.getCourse()
  }

  viewLesson(ev) {
    this.currentLessonTargets.forEach(element => {
      element.classList.remove("bg-shadow")
    });

    this.doCountDoneLessons(ev.target.dataset.sessionId)

    if (ev.target.checked) {
      ev.target.closest(".currentLesson").classList.add("bg-shadow")
      ev.target.closest(".currentLesson").nextElementSibling.classList.add("bg-shadow")
      var html = `<iframe src ="https://player.vimeo.com/video/${ev.target.dataset.link}" width="100%" height="${$(window).height() * 0.45}" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                  <p class="text-center my-1">${ev.target.dataset.name}</p>`
      
      this.totalProgressDuration += Number(ev.target.dataset.duration)
      this.totalProgressWatch += 1
      var controller = this
      new Promise(function (resolve) {
        resolve(controller.videoPlayerTarget.innerHTML = html)
      }).then(() => {
        controller.videoPlayerTarget.style.height = ($(window).height() * 0.4) + "px"
      }) 
    } else {
      this.totalProgressDuration -= Number(ev.target.dataset.duration)
      this.totalProgressWatch -= 1
    }

    var params = { progress: `${ev.target.dataset.sessionId}-${ev.target.dataset.id}-${ev.target.dataset.duration}-${ev.target.checked}` }
    this.saveCourseMetrics(params)
    // this.doProgressCount()
  }

  ratingCourse(ev) {
    var rating = ev.target.dataset.rating

    if (this.rating == 0 || this.rating == null) {
      this.setCourseRating(rating)
      this.saveCourseRating(rating)
    } else {
      this.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", "Você já nos avaliou! Muito obrigado!", 3000)
    }
    //★
    //☆
  }

  setCourseRating(rating) {
    this.ratingStarTargets.forEach(element => {
      if (element.dataset.rating <= rating) {
        element.innerHTML = `★`
      } else {
        element.innerHTML = `☆`
      }
    });
  }

  saveCourseRating(rating) {
    if (rating > 0) {
      this.rating = rating
      this.getControllerByIdentifier("app--shared--cookies").setCookie("course_rating", "", "Thu, 01 Jan 1970 00:00:00 UTC")
      const data = { course: { id: this.application.course.id, rating: rating } }
      this.requestUpdate(data)

      var params = { rating: rating }
      this.saveCourseMetrics(params)
    }
  }

  doCourseTitleHtml() {
    var html = `<div class="row d-flex align-items-center my-3">
                  <div class="col-12 text-center">
                    <img class="" src="https://medcapital-site-main.s3-sa-east-1.amazonaws.com/Logo-MedSchool.png" alt="MedSchool" class="image-10" style="width:10rem;cursor:pointer">
                  </div>
                </div>
                <div class="row d-flex align-items-center my-3">
                  <div class="col-12 text-center">
                    <h6 class="subtitle-two text-center my-0"><strong>${this.application.course.title}</strong></h6>
                  </div>
                </div>
                
                <div class="row d-flex align-items-center my-3">
                  <div class="col-6 text-center">
                    <div class="rating-star">
                      <span data-rating="5" data-action="click->${this.controllerName}#ratingCourse" data-${this.controllerName}-target="ratingStar">☆</span>
                      <span data-rating="4" data-action="click->${this.controllerName}#ratingCourse" data-${this.controllerName}-target="ratingStar">☆</span>
                      <span data-rating="3" data-action="click->${this.controllerName}#ratingCourse" data-${this.controllerName}-target="ratingStar">☆</span>
                      <span data-rating="2" data-action="click->${this.controllerName}#ratingCourse" data-${this.controllerName}-target="ratingStar">☆</span>
                      <span data-rating="1" data-action="click->${this.controllerName}#ratingCourse" data-${this.controllerName}-target="ratingStar">☆</span>
                    </div>
                  </div>
                  <div class="col-6 text-center">
                    <div class="w-100">
                      <button type="button" class="btn btn-outline dropdown-toggle w-100 p-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="s-title-0p6rem">Seu Progresso</span>
                        <div class="progress" style="height: 6px;overflow: inherit;">
                          <div class="progress-bar" role="progressbar" style="width: 0%;border-bottom:0.5rem solid #053B5E;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" data-${this.controllerName}-target="progressBar"></div>
                        </div>
                      </button>
                      <div class="dropdown-menu w-80">
                        <span class="s-title-0p6rem">Faltam <span data-${this.controllerName}-target="leftLessonsDuration"></span> de <span data-${this.controllerName}-target="totalLessonsDuration"></span> total</span><br>
                        <span class="s-title-0p6rem">Faltam <span data-${this.controllerName}-target="leftLessonsWatch"></span> de <span data-${this.controllerName}-target="totalLessonsWatch"></span> aulas</span><br>
                      </div>
                    </div>
                  </div>
                </div>`


    
    var controller = this
    new Promise(function (resolve) {
      resolve(controller.mainContentTarget.innerHTML = html)
    }).then(() => {
      controller.leftLessonsDurationTarget.innerText = this.getControllerByIdentifier("app--helpers--time").doDurationFormat(controller.leftLessonsDuration)
      controller.totalLessonsDurationTarget.innerText = this.getControllerByIdentifier("app--helpers--time").doDurationFormat(controller.totalLessonsDuration)
      controller.leftLessonsWatchTarget.innerText = controller.leftLessonsWatch
      controller.totalLessonsWatchTarget.innerText = controller.totalLessonsWatch
    })
  }

  doCourseContentHtml() {
    var html = `<div class="row my-3">
                  <div class="col-12 px-0" data-${this.controllerName}-target="videoPlayer"></div>
                </div>
                <div class="row my-3">
                  <div class="col-12 px-0" data-${this.controllerName}-target="courseSessions"></div>
                </div>
                <div class="row my-3">
                  <div class="col-12 px-0" data-${this.controllerName}-target="courseAbout"></div>
                </div>`

    this.mainContentTarget.insertAdjacentHTML("beforeend", html)
  }

  doCourseVideoHtml() {
    var html = `<img src="${this.application.course.cover_url}" alt="cover" width="100%;">`

    this.videoPlayerTarget.innerHTML = html    
  }

  doCourseAboutHtml() {
    var speakerHtml = ""
    this.speakers.forEach(speaker => {
      speakerHtml += `<div class="row d-flex align-items-center my-3">
                        <div class="col-1">
                          <img src="${speaker.speaker_avatar_url}" alt="${speaker.speaker_name}" style="width:3rem">
                        </div>
                        <div class="col-6">
                          <h5>${speaker.speaker_name}</h5>
                          <h6 class="trix-content">${speaker.speaker_bio}</h6>
                        </div>
                      </div>`
    });

    var html = `<div class="row my-5">
                  <div class="col-sm-12 px-0">
                    <ul class="nav nav-justified nav-tabs" id="justifiedTab" role="tablist">
                      <li class="nav-item">
                        <a aria-controls="home" aria-selected="true" class="nav-link nav-link-100 active" data-toggle="tab" href="#infoCourse" id="infoCourse-tab" role="tab">
                          Sobre o Curso
                        </a>
                      </li>
                      <li class="nav-item">
                        <a aria-controls="profile" aria-selected="false" class="nav-link nav-link-100" data-toggle="tab" href="#questions" id="questions-tab" role="tab">
                          Dúvidas Frequentes
                        </a>
                      </li>
                      <li class="nav-item">
                        <a aria-controls="contact" aria-selected="false" class="nav-link nav-link-100" data-toggle="tab" href="#materialContent" id="materialContent-tab"role="tab">
                          Materiais da Aula
                        </a>
                      </li> 
                      <li class="nav-item">
                        <a aria-controls="contact" aria-selected="false" class="nav-link nav-link-100" data-toggle="tab" href="#comments" id="comments-tab" role="tab">
                          Comentários
                        </a>
                      </li>
                    </ul>
                    <div class="tab-content" id="justifiedTabContent">
                      <div aria-labelledby="infoCourse-tab" class="tab-pane fade show active" id="infoCourse" role="tabpanel">
                        <div class="info-course-content h-80-classroom">
                          <div class="content pt-5">
                            <div class="col-lg-12 col-sm-12 mb-4">
                              <h1 class="title-class-course">Sobre o Curso</h1>
                            </div>
                            <div class="row">
                              <div class="col-lg-8 col-sm-12 description-course">
                                <h5 class="stitle-class-course">Descrição</h5>
                                ${this.application.course.description}
                              </div>
                              <div class="col-lg-4 col-sm-12"> 
                                <h5 class="stitle-class-course">Duração</h5>
                                <p class="">${this.getControllerByIdentifier("app--helpers--time").doDurationFormat(this.application.course.duration)}.</p>
                              </div>
                            </div>
                            <div class="col-12 data-${this.controllerName}-target="speakers"">
                              <h5 class="stitle-class-course">Palestrantes</h5>
                              ${speakerHtml}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div aria-labelledby="questions-tab" class="tab-pane fade" id="questions" role="tabpanel">
                        <div class="row d-flex align-items-center my-5">
                          <div class="col-sm-10 offset-sm-1">
                            <div class="accordion" id="accordionQuestionsCourse">
                              <div class="card" style="z-index:20;">
                                <div class="card-header" id="headingFour">
                                  <h5 class="mb-0 stitle-class-course">
                                    <button class="btn btn-link btn-wrap collapsed question" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                                      ${this.application.course.question_one}
                                    </button>
                                  </h5>
                                </div>
                                <div id="collapseOne" class="collapse" aria-labelledby="headingFour" data-parent="#accordionQuestionsCourse">
                                  <div class="card-body answer">
                                    <span id="answerFour">${this.application.course.answer_one}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="card" style="z-index:20;">
                                <div class="card-header" id="headingFour">
                                  <h5 class="mb-0">
                                    <button class="btn btn-link btn-wrap collapsed question" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                      ${this.application.course.question_two}
                                    </button>
                                </h5>
                              </div>
                              <div id="collapseTwo" class="collapse" aria-labelledby="headingFour" data-parent="#accordionQuestionsCourse">
                                <div class="card-body answer">
                                  <span id="answerFour">${this.application.course.answer_two}</span>
                                </div>
                              </div>
                              </div>
                              <div class="card" style="z-index:20;">
                                <div class="card-header" id="headingFour">
                                  <h5 class="mb-0">
                                    <button class="btn btn-link btn-wrap collapsed question" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                      ${this.application.course.question_three}
                                    </button>
                                  </h5>
                                </div>
                                <div id="collapseThree" class="collapse" aria-labelledby="headingFour" data-parent="#accordionQuestionsCourse">
                                  <div class="card-body answer">
                                    <span id="answerFour">${this.application.course.answer_three}</span>
                                  </div>
                                </div>
                              </div>
                            </div> 
                          </div>
                        </div>
                      </div>
                      <div aria-labelledby="materialContent-tab" class="tab-pane fade" id="materialContent" role="tabpanel">
                        <div class="h-80-classroom">
                          <div class="content pt-5">
                            <div class="col-lg-12 col-sm-12 mb-4">
                              <h1 class="title-class-course">Materiais Complementares</h1>
                            </div>
                            <div class="row">
                              <div class="col-lg-8 col-sm-12 description-course">
                                ${this.application.course.material_description}
                              </div>
                              <div class="col-lg-8 col-sm-12 description-course my-5">
                                <span class="btn btn-primary a-dark" data-action="click->${this.controllerName}#getCourseMaterial">Baixar Material</span>
                              </div>         
                            </div>
                          </div>
                        </div>
                      </div>
                      <div aria-labelledby="comments-tab" class="tab-pane fade" id="comments" role="tabpanel">
                        <div class="h-80-classroom">
                          <div class="content pt-3" data-controller="marketing--courses--comments--index">
                            <div data-marketing--courses--comments--index-target="commentInput"></div>
                            <div data-marketing--courses--comments--index-target="commentList"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>`
    
    this.courseAboutTarget.innerHTML = html
  }

  doCourseSessionsHtml() {
    var sessionsHtml = ``
    this.application.course.sessions_list.forEach(session => {
      var lessonsHtml = ``

      session.lessons_list.forEach(lesson => {

        lessonsHtml += `<tr class="currentLesson" data-${this.controllerName}-target="currentLesson">
                          <td class="table-10" rowspan="2">
                            <div class="custom-control custom-checkbox pl-1 d-flex align-items-center">
                              <input type="checkbox" class="custom-control-input" id="check-${lesson.id}" data-id="${lesson.id}" data-duration="${lesson.duration}" data-session-id="${session.id}" data-link="${lesson.link}" data-name="Parte ${session.order}: ${session.name} | ${lesson.order}: ${lesson.name}" data-${this.controllerName}-target="lessonCheckbox" data-action="click->${this.controllerName}#viewLesson">
                              <label class="custom-control-label pointer" for="check-${lesson.id}"></label>
                            </div>
                          </td>
                          <td scope="col" class="p-1 table-80 align-middle" style="height: 1rem">
                            ${lesson.order}: ${lesson.name}
                          </td>
                        </tr>
                        <tr style="font-size: 90%;" data-${this.controllerName}-target="currentLesson">
                          <td scope="col" class="p-1 table-80 align-middle" style="border:none;height: 1rem;font-size: 90%;"> 
                            <span class="material-icons md-150">play_circle_filled</span> ${this.getControllerByIdentifier("app--helpers--time").doDurationFormat(lesson.duration)}
                          </td>
                        </tr>`

      });

      sessionsHtml += `<div class="expansion-panel list-group-item session-${session.id}">
                        <a aria-controls="collapseSession-${session.id}" aria-expanded="false" class="expansion-panel-toggler collapsed" data-toggle="collapse" href="#collapseSession-${session.id}" id="headingSession-${session.id}">
                          <span>
                            <b>Parte ${session.order}: ${session.name}</b><br>
                            <span class="s-title-0p6rem"><span data-${this.controllerName}-target="doneLessons">0</span>/<span data-${this.controllerName}-target="totalLessons">${session.lessons_list.length}</span> | ${this.getControllerByIdentifier("app--helpers--time").doDurationFormat(session.duration)}</span>
                          </span>
                          <div class="expansion-panel-icon ml-3 text-black-secondary">
                            <i class="collapsed-show material-icons">keyboard_arrow_down</i>
                            <i class="collapsed-hide material-icons">keyboard_arrow_up</i>
                          </div>
                        </a>
                        <div aria-labelledby="headingSession-${session.id}" class="collapse" data-parent="#accordionTwo" id="collapseSession-${session.id}">
                          <div class="expansion-panel-body py-0">
                            <table class="table table-sm" style="font-size:80%;">
                              <tbody data-${this.controllerName}-target="lesson">
                                ${lessonsHtml}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>`
    });

    var html = `<div class="card">
                  <div class="card-body">
                    <h5 class="text-center title-course">Conteúdo ${this.application.course.kind_pretty}</h5>
                  </div>
                  <div class="list-group list-group-flush" id="accordionTwo">
                    ${sessionsHtml}
                  </div>
                </div>`

    this.courseSessionsTarget.innerHTML = html
  }

  doCountDoneLessons(sessionId) {
    var countLessons = 0
    if (this.hasLessonCheckboxTarget) {
      this.lessonCheckboxTargets.forEach(checkbox => {
        if ((sessionId == checkbox.dataset.sessionId) && (checkbox.checked)) {
          countLessons++
        }
      })
    }

    this.doneLessonsTargets.forEach(done => {
      if (done.closest(`.session-${sessionId}`)) {
        done.innerText = parseInt(countLessons)
      }
    });
  }

  saveCourseMetrics(params) {
    if (this.application.current_user) {
      var userId = this.application.current_user.id
    } else if (this.getControllerByIdentifier("app--shared--cookies").getCookie("ahoy_visitor")) {
      var visitorToken = this.getControllerByIdentifier("app--shared--cookies").getCookie("ahoy_visitor")
    }

    if (this.application.metrics) {
      var data = { metric: { id: this.application.metrics.id, course_id: this.application.course.id, user_id: userId, visitor_token: visitorToken, progress: params.progress, rating: params.rating } }
    } else {
      var data = { metric: { course_id: this.application.course.id, user_id: userId, visitor_token: visitorToken, progress: params.progress, rating: params.rating } }
    }

    const token = $('meta[name=csrf-token]').attr('content');
    const url = "/marketing/courses/metrics/save_public"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.save) {
          var metrics = response.data.cln
          controller.application.metrics = metrics

        } else {
          controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar(response.type, response.message, 3000)
        }
      })
      .catch(error => {
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", controller.getControllerByIdentifier("app--helpers--messages").generalError(), 3000)
      })
  }

  doProgressCount() {
    var totalLessons = 0
    this.sessions.forEach(element => {
      totalLessons += element.lessons_list.length
    });

    this.leftLessonsDurationTarget.innerText = this.getControllerByIdentifier("app--helpers--time").doDurationFormat(this.application.course.duration - this.totalProgressDuration)
    this.leftLessonsWatchTarget.innerText = totalLessons - this.totalProgressWatch

    this.progressBarTarget.style.width = (this.totalProgressDuration / this.application.course.duration) * 100 + `%`
  }

  requestUpdate(data) {
    const token = $('meta[name=csrf-token]').attr('content');
    const url = "/marketing/courses/entities/update_public"
    const init = { method: "PUT", credentials: "same-origin", headers: { "X-CSRF-Token": token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar(response.type, response.message, 3000)
      })
      .catch(error => {
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", controller.getControllerByIdentifier("app--helpers--messages").generalError(), 3000)
      })
  }

  getCourseMaterial() {
    window.open(this.application.course.material_url, `_blank`)
  }

  setDoneLessons(progress) {
    progress.forEach(element => {
      var sessionId = element.split("-")[0]
      var lessonId = element.split("-")[1]

      if (this.hasLessonCheckboxTarget) {
        this.lessonCheckboxTargets.forEach(checkbox => {
          if ((sessionId == checkbox.dataset.sessionId) && (lessonId == checkbox.dataset.id)) {
            checkbox.checked = true
          }
        })
      }
      this.doCountDoneLessons(sessionId)
    });
  }

  getCourse() {
    var data = { course: { slug: this.courseSlug } }
    const token = $('meta[name=csrf-token]').attr('content');
    const url = "/marketing/courses/entities/read_public"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.process) {
          controller.application.course = response.data.cln
          controller.sessions = controller.application.course.sessions_list
          controller.speakers = controller.application.course.speakers_list
          controller.application.comments = controller.application.course.comments_list


          controller.leftLessonsDuration = controller.application.course.duration
          controller.totalLessonsDuration = controller.application.course.duration
          controller.leftLessonsWatch = controller.application.course.total_lessons
          controller.totalLessonsWatch = controller.application.course.total_lessons

          controller.doCourseTitleHtml()
          controller.doCourseContentHtml()
          controller.doCourseVideoHtml()
          controller.doCourseSessionsHtml()
          controller.doCourseAboutHtml()
          controller.getCourseMetrics()
        } else {
          controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar(response.type, response.message, 3000)
        }
      })
      .catch(error => {
        controller.getControllerByIdentifier("app--helpers--console").console(error)
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", controller.getControllerByIdentifier("app--helpers--messages").generalError(), 3000)
      })
  }

  getCourseMetrics() {
    if (this.application.current_user) {
      var userId = currentUser.id
    } else if (this.getControllerByIdentifier("app--shared--cookies").getCookie("ahoy_visitor")) {
      var visitorToken = this.getControllerByIdentifier("app--shared--cookies").getCookie("ahoy_visitor")
    }
    var data = { metric: { course_id: this.application.course.id, user_id: userId, visitor_token: visitorToken } }

    const token = $('meta[name=csrf-token]').attr('content');
    const url = "/marketing/courses/metrics/read_public"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.save) {
          var metrics = response.data.cln
          controller.application.metrics = metrics

          controller.rating = metrics.rating
          controller.setCourseRating(metrics.rating)

          controller.setDoneLessons(metrics.progress)
          controller.totalProgressDuration = metrics.duration_progress
          controller.totalProgressWatch = metrics.lessons_progress
          // controller.doProgressCount()

        } else {
          controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar(response.type, response.message, 3000)
        }
      })
      .catch(error => {
        controller.getControllerByIdentifier("app--helpers--console").console(error)
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", controller.getControllerByIdentifier("app--helpers--messages").generalError(), 3000)
      })
  }

  doCoursePreloaderHtml() {
    var html = `<div class="row d-flex align-items-center my-3">
                  <div class="col-12 text-center">
                    <img class="" src="https://medcapital-site-main.s3-sa-east-1.amazonaws.com/Logo-MedSchool.png" alt="MedSchool" class="image-10" style="width:10rem;cursor:pointer">
                  </div>
                </div>
                <div class="row d-flex align-items-center my-3">
                  <div class="col-12">
                    <div class='card timeline-item m-0 p-1 w-100' style="box-shadow:none;max-width:none;">
                      <div class='animated-background animated-background-5'>
                        <div class='background-masker title'></div>
                      </div>
                    </div>
                    <div class='card timeline-item m-0 p-1 w-100' style="box-shadow:none;max-width:none;">
                      <div class='animated-background animated-background-5'>
                        <div class='background-masker title'></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row d-flex align-items-center my-3">
                  <div class="col-6">
                    <div class='card timeline-item m-0 p-1 w-100' style="box-shadow:none;max-width:none;">
                      <div class='animated-background animated-background-5'>
                        <div class='background-masker title'></div>
                      </div>
                    </div>
                    <div class='card timeline-item m-0 p-1 w-100' style="box-shadow:none;max-width:none;">
                      <div class='animated-background animated-background-5'>
                        <div class='background-masker title'></div>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class='card timeline-item m-0 p-1 w-100' style="box-shadow:none;max-width:none;">
                      <div class='animated-background animated-background-5'>
                        <div class='background-masker title'></div>
                      </div>
                    </div>
                    <div class='card timeline-item m-0 p-1 w-100' style="box-shadow:none;max-width:none;">
                      <div class='animated-background animated-background-5'>
                        <div class='background-masker title'></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row d-flex align-items-center my-3">
                  <div class="col-12 my-3">
                    <div class='card timeline-item m-0 p-1 w-100' style="box-shadow:none;max-width:none;">
                      <div class='animated-background animated-background-5'>
                        <div class='background-masker title'></div>
                      </div>
                    </div>
                    <div class='card timeline-item m-0 p-1 w-100' style="box-shadow:none;max-width:none;">
                      <div class='animated-background animated-background-5'>
                        <div class='background-masker title'></div>
                      </div>
                    </div>
                    <div class='card timeline-item m-0 p-1 w-100' style="box-shadow:none;max-width:none;">
                      <div class='animated-background animated-background-5'>
                        <div class='background-masker title'></div>
                      </div>
                    </div>
                    <div class='card timeline-item m-0 p-1 w-100' style="box-shadow:none;max-width:none;">
                      <div class='animated-background animated-background-5'>
                        <div class='background-masker title'></div>
                      </div>
                    </div>
                    <div class='card timeline-item m-0 p-1 w-100' style="box-shadow:none;max-width:none;">
                      <div class='animated-background animated-background-5'>
                        <div class='background-masker title'></div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 my-3">
                    <div class='card timeline-item m-0 p-1 w-100' style="box-shadow:none;max-width:none;">
                      <div class='animated-background animated-background-5'>
                        <div class='background-masker title'></div>
                      </div>
                    </div>
                    <div class='card timeline-item m-0 p-1 w-100' style="box-shadow:none;max-width:none;">
                      <div class='animated-background animated-background-5'>
                        <div class='background-masker title'></div>
                      </div>
                    </div>
                    <div class='card timeline-item m-0 p-1 w-100' style="box-shadow:none;max-width:none;">
                      <div class='animated-background animated-background-5'>
                        <div class='background-masker title'></div>
                      </div>
                    </div>
                    <div class='card timeline-item m-0 p-1 w-100' style="box-shadow:none;max-width:none;">
                      <div class='animated-background animated-background-5'>
                        <div class='background-masker title'></div>
                      </div>
                    </div>
                    <div class='card timeline-item m-0 p-1 w-100' style="box-shadow:none;max-width:none;">
                      <div class='animated-background animated-background-5'>
                        <div class='background-masker title'></div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 my-3">
                    <div class='card timeline-item m-0 p-1 w-100' style="box-shadow:none;max-width:none;">
                      <div class='animated-background animated-background-5'>
                        <div class='background-masker title'></div>
                      </div>
                    </div>
                    <div class='card timeline-item m-0 p-1 w-100' style="box-shadow:none;max-width:none;">
                      <div class='animated-background animated-background-5'>
                        <div class='background-masker title'></div>
                      </div>
                    </div>
                    <div class='card timeline-item m-0 p-1 w-100' style="box-shadow:none;max-width:none;">
                      <div class='animated-background animated-background-5'>
                        <div class='background-masker title'></div>
                      </div>
                    </div>
                    <div class='card timeline-item m-0 p-1 w-100' style="box-shadow:none;max-width:none;">
                      <div class='animated-background animated-background-5'>
                        <div class='background-masker title'></div>
                      </div>
                    </div>
                    <div class='card timeline-item m-0 p-1 w-100' style="box-shadow:none;max-width:none;">
                      <div class='animated-background animated-background-5'>
                        <div class='background-masker title'></div>
                      </div>
                    </div>
                  </div>
                </div>`

    this.mainContentTarget.insertAdjacentHTML("beforeend", html)
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

}
